import VueI18n from "vue-i18n"
import Vue from "vue"

Vue.use(VueI18n)

const messages = {
    'en': require('@/locales/en.json'),
    'fi': require('@/locales/fi.json')
}

const dateTimeFormats = {
    fi: {
        long: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        },
        shortDate: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        },
    },
    en: {
        long: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric'
        },
        shortDate: {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
        },
    }
}

const i18n = new VueI18n({
    locale: localStorage.getItem("language") ?? navigator.language.split('-')[0], // set locale,
    fallbackLocale: 'en',
    messages,
    dateTimeFormats
})

export default i18n;